<sm-spinner [loading]="loading$"></sm-spinner>
<div class="my-5">
    <sm-page-header [breadcrumb]="breadcrumb" title="dac.dacConfiguration.title"></sm-page-header>
    <!-- content -->
    <div class="flex flex-row gap-5">
        <!-- Form -->
        <div class="flex flex-col gap-4 w-3/4">
            <div class="content">
                <sm-form-builder [formObject]="formObject"></sm-form-builder>
            </div>
        </div>

        <!-- Meta Blocks / Actions -->
        <div class="flex flex-col gap-2 w-1/4 sticky top-5 h-full">
            <div class="content flex flex-col gap-2">
                <p-button label="Enregistrer" icon="pi pi-save" severity="success" [loading]="!!(loading$ | async)"
                    (onClick)="save()" styleClass="w-full"></p-button>
                <p-button label="Réinitialiser" icon="pi pi-refresh" severity="secondary" [loading]="!!(loading$ | async)"
                    (onClick)="reset()" styleClass="w-full"></p-button>
            </div>
        </div>
    </div>
</div>
